exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#drgs{font-size:120%}#drgs__notification{min-width:auto}#drgs__notification button{display:none}#drgs .drg-input{margin-top:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/admin/drgs/drgs.styl
// module id = 51
// module chunks = 1